import React from 'react';
import RocketData from '../components/RocketData';

import '../style/rocket.css';

const Rocket = () => (
  <div className="Rocket">
    <RocketData />
  </div>
);

export default Rocket;
